'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _radium = require('radium');

var _radium2 = _interopRequireDefault(_radium);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (_typeof(call) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + _typeof(superClass));
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var styles = {
  wrapper: {
    position: 'fixed',
    left: '0',
    right: '0'
  },
  frame: {
    width: '400px',
    height: '25px',
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto',
    color: 'white',
    display: 'table'
  },
  text: {
    display: 'table-cell',
    verticalAlign: 'middle'
  },
  shown: {
    display: 'block'
  },
  hidden: {
    display: 'none'
  },
  success: {
    backgroundColor: '#5CB85C'
  },
  error: {
    backgroundColor: '#D9534F'
  },
  info: {
    backgroundColor: '#5bc0de'
  }
};
var subscribers = [];

var emitNotification = function emitNotification(_ref) {
  var level = _ref.level,
      message = _ref.message,
      display = _ref.display;
  subscribers.forEach(function (fn) {
    fn({
      level: level,
      message: message,
      display: display
    });
  });
};

var show = function show(_ref2) {
  var level = _ref2.level,
      message = _ref2.message;
  emitNotification({
    level: level,
    message: message,
    display: 'shown'
  });
  setTimeout(function () {
    emitNotification({
      level: '',
      message: '',
      display: 'hidden'
    });
  }, 3000);
};

var _Notification = function (_Component) {
  _inherits(_Notification, _Component);

  function _Notification(props) {
    _classCallCheck(this, _Notification);

    var _this = _possibleConstructorReturn(this, (_Notification.__proto__ || Object.getPrototypeOf(_Notification)).call(this, props));

    _this.state = {
      level: '',
      message: '',
      display: 'hidden'
    };
    _this.setNotification = _this.setNotification.bind(_this);
    return _this;
  }

  _createClass(_Notification, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      subscribers.push(this.setNotification);
    }
  }, {
    key: 'setNotification',
    value: function setNotification(_ref3) {
      var level = _ref3.level,
          message = _ref3.message,
          display = _ref3.display;
      this.setState({
        level: level,
        message: message,
        display: display
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2["default"].createElement('div', {
        style: [styles.wrapper, styles[this.state.display]]
      }, _react2["default"].createElement('div', {
        style: [styles.frame, styles[this.state.level]]
      }, _react2["default"].createElement('div', {
        style: styles.text
      }, this.state.message)));
    }
  }]);

  return _Notification;
}(_react.Component);

var component = (0, _radium2["default"])(_Notification);
exports["default"] = {
  component: component,
  show: show
};